import React from "react";

const ALERT_PHASES = new Set([
  "permission-denied",
  "unavailable",
  "audio-failure",
  "error",
]);

export function EdenVoiceInputStatus({ snapshot = {} }) {
  const phase = String(snapshot.phase || "idle");
  const isAlert = ALERT_PHASES.has(phase);

  return (
    <div
      className="cphere-voice-panel-status"
      data-voice-input-state={phase}
      role={isAlert ? "alert" : "status"}
      aria-live={isAlert ? "assertive" : "polite"}
      aria-atomic="true"
    >
      {String(snapshot.message || "")}
    </div>
  );
}

export default EdenVoiceInputStatus;
